import httpHelper from "@/helpers/httpHelper";
import _ from "lodash"
// action types
export const GET_ROLES = "getRoles";

// mutation types
export const SET_ROLES = "setRoles";


export default {
    state: {

        roleList: null,

    },
    getters: {

        loadedRoleList(state) {
            return state.roleList;
        },

    },
    actions: {
        /**
         * Get the role 
         * @param state
         * @param payload
         */
        [GET_ROLES](state, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(payload)
                    .then((response) => {
                        if (response.success) {
                            state.commit(SET_ROLES, response.result);
                        }

                    })
                    .catch((error) => {
                    })
                    .finally(() => { });
            });
        },


    },
    mutations: {
        /**
                 * Set the role 
                 * @param state
                 * @param payload
                 */
        [SET_ROLES](state, payload) {
            let obj = {};
            let ary = [];
            payload.forEach(element => {
                ary.push(Object.assign(obj, { value: element.id, text: element.name }));
                obj = {};
            });
            state.roleList = ary;
        },


    }
};